import { ArrowRight } from "@magnetic/icons";
import { Text } from "@magnetic/text";

import { HFlex } from "src/components/hFlex";
import { VFlex } from "src/components/vFlex";

import { BOT_SETUP_STEPS } from "../constants";

import { StepCard } from "./stepCard";

import "./setupSteps.scss";

interface SetupStepsProps {
  readonly className?: string;
}

/**
 * Displays a horizontal step-by-step process with cards for bot setup
 */
export const SetupSteps = ({ className = "" }: SetupStepsProps) => {
  const [step1, step2, step3, step4] = BOT_SETUP_STEPS;

  return (
    <HFlex gap={0} align="flex-start" className={`setup-steps ${className}`}>
      <VFlex gap="sm" align="center" className="step-card-wrapper">
        <HFlex gap={0} align="center">
          <StepCard {...step1} />
          <ArrowRight size={16} weight="bold" />
          <StepCard {...step2} />
        </HFlex>
        {step1.completedText && (
          <Text size="p5" color="light">
            {step1.completedText}
          </Text>
        )}
      </VFlex>
      <div className="app-user-step-arrow">
        <ArrowRight size={16} weight="bold" />
      </div>
      <div className="app-user-step-card">
        <StepCard {...step3} />
      </div>
      <div className="app-user-step-arrow">
        <ArrowRight size={16} weight="bold" />
      </div>
      <VFlex gap="sm" align="center" className="step-card-wrapper">
        <StepCard {...step4} />
        {step4.completedText && (
          <Text size="p5" color="light">
            {step4.completedText}
          </Text>
        )}
      </VFlex>
    </HFlex>
  );
};
